const formatDateString = require('../../../common/utility/date-stringformatter');
module.exports = function RescheduleConfirmation($rootScope,$window,$stateParams,RescheduleDeliveryService) {
    return {
        restrict: 'E',
        scope: true,
        
        template: require('./rescheduleconfirmation-template.html'),
        link(scope) {
            $rootScope.orderNumber = $stateParams.ordernumber;
            scope.deliveryDay = atob($stateParams.day);
            scope.deliveryTime = atob($stateParams.time);
            scope.loading = false;
            scope.showInvalidResponse = false;
            scope.showRescheduleConfirmation = false;

            RescheduleDeliveryService.OrdersReschedule($rootScope.orderNumber).then((response) => {
                if (response == undefined || response.ErrorMessage != null) {
                    scope.showInvalidResponse = true;
                }
                else{
                    scope.showRescheduleConfirmation = true;
                    scope.reschDetails = response;
                    scope.isGuestOrder = scope.reschDetails.IsGuest;                    
                }
            })
            .catch(() => {
                scope.showInvalidResponse = true;
            });

            scope.deliveryDayFull = new Date(formatDateString(scope.deliveryDay));

            scope.isToday = (usrFrndlyDate) => {
                const today = new Date();
                const dateObj = new Date(formatDateString(usrFrndlyDate));
            
                return dateObj.getDate() === today.getDate() &&
                    dateObj.getMonth() === today.getMonth() &&
                    dateObj.getFullYear() === today.getFullYear();
            };

            scope.isTomorrow = (usrFrndlyDate) => {
                const today = new Date();
                const dateObj = new Date(formatDateString(usrFrndlyDate));
            
                return dateObj.getDate() === today.getDate()+1 &&
                    dateObj.getMonth() === today.getMonth() &&
                    dateObj.getFullYear() === today.getFullYear();
            };

            scope.assignDateTime = function (deliveryTimeRange) {
                const regex = /(\d{1,2}) ([ap]m) - (\d{1,2}) ([ap]m)/i; 
                const match = regex.exec(deliveryTimeRange);
              
                if (match) {                              
                const startHour = parseInt(match[1], 10);
                const startPeriod = match[2].toLowerCase();
                const endHour = parseInt(match[3], 10);
                const endPeriod = match[4].toLowerCase();
              
                const formattedStartTime = `${startHour.toString().padEnd(2, "")}:00 ${startPeriod}`; 
                const formattedEndTime = `${endHour.toString().padEnd(2, "")}:00 ${endPeriod}`;
              
                return `${formattedStartTime} - ${formattedEndTime}`;
                }
              };         

            scope.formattedDeliveryTime = scope.assignDateTime(scope.deliveryTime);

             
            var backEvent = function (event) {
                history.pushState(null, null, window.location.href); //Capture the initial state of the page and push it
            };
            history.pushState(null, null, window.location.href);

            $window.addEventListener('popstate', backEvent, true) //Capture page's initial state

            $rootScope.$on("$locationChangeStart",function()
            {   if(backEvent) {
                    $window.removeEventListener('popstate', backEvent, true); 
                } backEvent = null;
            });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/rescheduleconfirmation/rescheduleconfirmation-directives.js
 **/